__turbopack_context__.v({
  "avatarCell": "_jNDPa_avatarCell",
  "resumeTeaserGrid": "_jNDPa_resumeTeaserGrid",
  "resumeTeaserTitle": "_jNDPa_resumeTeaserTitle",
  "resumeTeaserWrapper": "_jNDPa_resumeTeaserWrapper",
});
